import instance from '@/http/http.js';

//可转债列表
function cbondList(params){
    return new Promise((resolve,reject)=>{
        instance.post('/licai/cbondList',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}
//待发转债列表
function waitPublishCbondList(params){
    return new Promise((resolve,reject)=>{
        instance.post('/licai/waitPublishCbond',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}
//已退市转债列表
function quitCbondList(params){
    return new Promise((resolve,reject)=>{
        instance.post('/licai/quitCbond',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//股息率列表
function guXiLvList(params){
    return new Promise((resolve,reject)=>{
        instance.post('/licai/guXiLv',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//新股申购列表
function newStockList(params){
    return new Promise((resolve,reject)=>{
        instance.post('/licai/newStock',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}
//新股上市列表
function newStockListed(params){
    return new Promise((resolve,reject)=>{
        instance.post('/licai/newStockListed',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}
//次新股列表
function beforeNewStockList(params){
    return new Promise((resolve,reject)=>{
        instance.post('/licai/beforeNewStock',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//欧美QDII列表
function QDIIDataList(params){
    return new Promise((resolve,reject)=>{
        instance.post('/licai/QDIIData',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//亚洲QDII列表
function asiaQDIIDataList(params){
    return new Promise((resolve,reject)=>{
        instance.post('/licai/asiaQDIIData',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//现金管理-上海回购列表
function cashRepoDataList(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Licai/cashRepoData',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}
//交易所T+0货基
function cashCurrFundETFList(params){
    return new Promise((resolve,reject)=>{
        instance.post('/licai/cashCurrFundETF',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//银行T+0理财
function cashDataList(params){
    return new Promise((resolve,reject)=>{
        instance.post('/licai/cashData',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//股票LOF
function LOFDataList(params){
    return new Promise((resolve,reject)=>{
        instance.post('/licai/LOFData',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//指数ETF
function ETFDataList(params){
    return new Promise((resolve,reject)=>{
        instance.post('/licai/ETFData',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//封闭基金
function closeStockFundList(params){
    return new Promise((resolve,reject)=>{
        instance.post('/licai/closeStockFund',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}
//AH比价
function AHcontrastList(params){
    return new Promise((resolve,reject)=>{
        instance.post('/licai/AHcontrast',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}
//债券
function bondDataList(params){
    return new Promise((resolve,reject)=>{
        instance.post('/licai/bondData',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//基金分类
function fundCategoryList(params){
    return new Promise((resolve,reject)=>{
        instance.post('/fund/fundCategory',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//基金列表
function dataListList(params){
    return new Promise((resolve,reject)=>{
        instance.post('/fund/dataList',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//股票 市场总览
function marketOverview(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Stock/marketOverview',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//推荐指数
function recommendIndex(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Stock/recommendIndex',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//热门板块
function hotPlate(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Stock/hotPlate',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//北向资金（今日）
function northMoney(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Stock/northMoney',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//南向资金（今日）
function southMoney(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Stock/southMoney',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//北向/南向资金（历史每日）
function northHistoryDay(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Stock/northHistoryDay',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//北向/南向资金（历史每周）
function northHistoryWeek(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Stock/northHistoryWeek',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

export {
  AHcontrastList,
  asiaQDIIDataList,
  beforeNewStockList,
  bondDataList,
  cashCurrFundETFList,
  cashDataList,
  cashRepoDataList,
  cbondList,
  closeStockFundList,
  dataListList,
  ETFDataList,
  fundCategoryList,
  guXiLvList,
  hotPlate,
  LOFDataList,
  marketOverview,
  newStockList,
  newStockListed,
  northHistoryDay,
  northHistoryWeek,
  northMoney,
  QDIIDataList,
  quitCbondList,
  recommendIndex,
  southMoney,
  waitPublishCbondList,
};